
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trim/configurable/[...model]",
      function () {
        return require("private-next-pages/trim/configurable/[...model].tsx");
      }
    ]);
  